import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { AppRoot } from "./app.js";
import { createAppQueryClient } from "./data/query-client.js";
import { applyPlace } from "./design/place.js";
import { routeFromHash } from "./routes.js";
import "./design/app.css";

/**
 * The query client's defaults and its one cache rule (a 401 or a pending
 * account's refusal asks who this is again) live in data/query-client.ts,
 * where a test holds them. The root decides between the app and the grace
 * notice of a pending account deletion.
 */
const queryClient = createAppQueryClient();

const container = globalThis.document.getElementById("root");
if (container === null) throw new Error("main: #root is missing from index.html");

// The place before the first paint (2026-11-02): the address already says
// whether this is the study or the book, so a cold load of the study never
// shows one light frame before the app's own effect runs (design/place.ts).
applyPlace(routeFromHash(globalThis.location.hash));

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRoot />
    </QueryClientProvider>
  </StrictMode>,
);
